import { UserAvatar } from './UserAvatar';

export * from './UserAvatar.types';
export { UserAvatar };

export default UserAvatar;
